'use strict';

angular.module( 'angus.directives' ).directive( 'callbackAnalysis', [
	'actionViewTemplates',
	function( actionViewTemplates ) {
		return {
			scope: {
				model: '=actionModel',
				settings: '=callbackAnalysisWidgetSettings',
				widgetCode : '='
			},
			templateUrl: actionViewTemplates.callbackAnalysisReportContainer
		};
	}
] );